/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  AccountService,
  ForgotPasswordInput,
  ImpersonateTenantInput,
  IsTenantAvaibleOutput,
  ResetPasswordInput,
} from '@services';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';

declare const abp: any;
class AccountStore {
  tenant: IsTenantAvaibleOutput = new IsTenantAvaibleOutput();

  constructor() {
    makeAutoObservable(this);
  }

  public isTenantAvailable = async (tenancyName: string) => {
    const tenant = await AccountService.isTenantAvailable({ tenancyName });

    runInAction(() => {
      this.tenant = tenant;
    });
  };

  public impersonateTenantToken = async (input: ImpersonateTenantInput) => {
    const result = await AccountService.impersonateTenantToken(input);
    return result;
  };

  public backToImpersonator = async () => {
    const result = await AccountService.backToImpersonator();
    return result;
  };

  public impersonateLogin = async (impersonationToken: string) => {
    const result = await AccountService.impersonateLogin(impersonationToken);
    abp.auth.setToken(result.accessToken, undefined);
  };

  public sendPasswordResetCode = async (input: ForgotPasswordInput) => {
    try {
      await AccountService.sendPasswordResetCode(input);
      message.success({
        content: 'Password reset link was sent to your email!',
      });
    } catch (error: any) {
      const customError = new Error(
        'Email address was not found or email address is not verified.'
      );
      (customError as any).isValidation = true;
      throw customError;
    }
  };

  public resetPassword = async (input: ResetPasswordInput) => {
    await AccountService.resetPassword(input);
  };
}

export default AccountStore;
